import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'
import StyleLink from './dev/StyleLink'

const PageNotFound = ({ messages }) => {
    return (
        <Wrapper>
            <Container>
                <Content>
                    <Title>
                        <div>{messages['404_coming_soon_01']}</div>
                        <div>{messages['404_coming_soon_02']}</div>
                    </Title>
                    <SubTitle>
                        <div>{messages['404_comingsoon_01']}</div>
                        <div>{messages['404_comingsoon_02']}</div>
                        <div>{messages['404_comingsoon_03']}</div>
                    </SubTitle>
                    <StyleLink to={`/`}>
                        <ReadMore>{messages['404_learn_more']}</ReadMore>
                    </StyleLink>
                </Content>
            </Container>
        </Wrapper>
    )
}
const mapStateToProps = state => {
    return {
        messages: state.Messages
    }
}
export default connect(mapStateToProps)(PageNotFound);
const Wrapper = styled.div`
    min-height: 100vh;    
    overflow: scroll;
    background-color: #fafafa;
    border-left: 1px solid #e6e6e6;
`
const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center; 
    width: 100%;
    height: auto;
    padding: 50px 0;
`
const Content = styled.div`
    display: flex;
    /* justify-content: space-between; */
    flex-direction: column;
    align-items: center;
    min-width: 900px;
    padding: 36px;
    margin-bottom: 32px;
    background-color: #fff;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);         
    color: #787878;
    @media (max-width: 900px){
        min-width: 320px;
        margin: 0 10px;
    } 
`
const Title = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    font-size: 36px;
    font-weight: 500;
    @media (max-width: 900px){
        font-size: 24px;
    }
`
const SubTitle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;
    font-size: 20px;
    font-weight: 300;
    @media (max-width: 900px){
        font-size: 14px;
    }
`
const ReadMore = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 160px;
    height: 40px;
    margin-top: 24px;
    background-color: #de0606;
    font-size: 20px;
    font-weight: 500;
    color: #fff;
    cursor: pointer;
`


// WEBPACK FOOTER //
// ./src/404.js